import toast from '@/lib/cinnamon-toast/CinnamonToast.js'

export default {
  install (Vue, options) {
    Vue.prototype.$toast = toast
  }
}
